import React from "react";
import { makeStyles } from "tss-react/mui";
import { Bucket, Buckets } from "@miplatform/components";
import {
  IAttemptListItemResponseForWorkOrder,
  IAttemptListResponse,
  PopperPlacement,
} from "@miplatform/types";
import { Box } from "@mui/material";
import { MiWorkBoardItem } from "../../../../components/MiWorkBoard";
import { useCalendarContext } from "../../../../providers";
import { OrderInfoCard as OrderInfoCardUntyped } from "../../../Orders/OrdersList/OrderInfoCard/OrderInfoCard";
import { NhcOrderCard } from "../../NhcOrderCard";

export const KanbanCalendarTrays: React.FC<KanbanCalendarTraysProps> = ({
  orderReasons,
  setSelectedOrder,
}) => {
  const { classes, theme } = useKanbanCalendarTraysStyles();
  const {
    trayBuckets,
    calendarSet,
    refreshData = () => null,
  } = useCalendarContext();

  const handleBucketCardClick = (
    order: IAttemptListResponse | IAttemptListItemResponseForWorkOrder
  ) => {
    setSelectedOrder(order);
  };

  if (trayBuckets.length === 0) {
    return null;
  }

  return (
    <Box className={classes.bucketContainer}>
      <Buckets>
        {trayBuckets.map((bucket) => (
          <Bucket key={bucket.name} bucket={bucket} initialCollapsed>
            {(bucket.data || []).map(
              (
                order:
                  | IAttemptListResponse
                  | IAttemptListItemResponseForWorkOrder
              ) => {
                const holdType = order?.assignment?.order?.holdCalendarId
                  ? calendarSet?.calendars?.[
                      order.assignment.order.holdCalendarId
                    ]?.config?.name
                  : undefined;
                return (
                  <MiWorkBoardItem
                    onClick={() => handleBucketCardClick(order)}
                    className={classes.bucketItem}
                    key={order.id}
                  >
                    <NhcOrderCard
                      data={order}
                      onRefresh={refreshData}
                      orderReasons={orderReasons}
                      setSelectedOrder={setSelectedOrder}
                      calendarSet={calendarSet}
                      headerColor={
                        order.assignment?.order?.orderTemplateColor ??
                        theme.palette.grey.primary
                      }
                      isInBucket
                      holdType={holdType}
                      popperPlacement={PopperPlacement.Top}
                      popperComponent={
                        <OrderInfoCard
                          order={{
                            home: order.home,
                            ...order?.assignment?.order,
                            notes: order?.assignment?.order?.orderNotes,
                          }}
                          holdType={holdType}
                        />
                      }
                    />
                  </MiWorkBoardItem>
                );
              }
            )}
          </Bucket>
        ))}
      </Buckets>
    </Box>
  );
};

const useKanbanCalendarTraysStyles = makeStyles()(() => ({
  bucketContainer: {
    display: "flex",
    position: "sticky",
    bottom: 0,
  },
  bucketItem: {
    maxWidth: 170,
  },
}));

const OrderInfoCard = OrderInfoCardUntyped as React.FC<{
  order: any;
  fieldsConfig?: any;
  holdType?: string;
}>;

interface KanbanCalendarTraysProps {
  setSelectedOrder: (
    order:
      | IAttemptListResponse
      | IAttemptListItemResponseForWorkOrder
      | undefined
  ) => void;
  orderReasons: {
    holdReasons: { value: string; label: string }[];
    rescheduleReasons: { value: string; label: string }[];
  };
}
